// RegExp to check if string ends with date format yyyy_mm_dd
export const fileNameHasDate = (fileName = '') => /\d{4}_(0[1-9]|1[012])_(0[1-9]|[12][0-9]|3[01])$/g.test(fileName);
